import { createAction } from '@reduxjs/toolkit';

export interface ApiAuthRefreshTokenPayload {
  readonly actionId: number;
}
export const apiAuthRefreshTokenRequestedType = 'api/auth/refreshToken--requested';
export const apiAuthRefreshTokenRequested = createAction<ApiAuthRefreshTokenPayload>(
  apiAuthRefreshTokenRequestedType
);
export type ApiAuthRefreshTokenRequestedAction = ReturnType<typeof apiAuthRefreshTokenRequested>;

export interface ApiAuthRefreshTokenSucceededPayload {
  readonly requestedActionId: number;
  readonly tokens: {
    readonly accessToken: string;
    readonly expiresAtTsSeconds: number;
    readonly expiresInSeconds: number;
    readonly refreshToken: string | null;
  };
}

export enum ApiAuthRefreshTokenFailedReason {
  TOKEN_INVALID,
  OTHER
}

export const apiAuthRefreshTokenSucceededType = 'api/auth/refreshToken--succeeded';
export const apiAuthRefreshTokenSucceeded = createAction<
  ApiAuthRefreshTokenSucceededPayload,
  typeof apiAuthRefreshTokenSucceededType
>(apiAuthRefreshTokenSucceededType);
export type ApiAuthRefreshTokenSucceededAction = ReturnType<typeof apiAuthRefreshTokenSucceeded>;

export interface ApiAuthRefreshTokenFailedPayload {
  readonly requestedActionId: number;
  readonly reason: ApiAuthRefreshTokenFailedReason;
}
export const apiAuthRefreshTokenFailedType = 'api/auth/refreshToken--failed';
export const apiAuthRefreshTokenFailed = createAction<
  ApiAuthRefreshTokenFailedPayload,
  typeof apiAuthRefreshTokenFailedType
>(apiAuthRefreshTokenFailedType);
export type ApiAuthRefreshTokenFailedAction = ReturnType<typeof apiAuthRefreshTokenFailed>;
